@if (createdAtRelative !== null) {
  <span class="suggestion-meta-time">{{ createdAtRelative }}</span>
}
<div class="suggestion-meta-author-info">
  <app-avatar [input]="authorName" size="small" class="suggestion-meta-avatar"></app-avatar>
  <span class="suggestion-meta-author-name">{{ authorName }}</span>
</div>
